import { defineStore } from "pinia";
import axios from "axios";
import { useLoadingStore } from "@/stores/loadingStore";

export const useMenuStore = defineStore("menuStore", {
  state: () => ({
    navbarMenu: [],
    authMenu: [],
    footerMenuGroups: [],
    isLoading: false,
    error: null,
  }),
  actions: {
    async fetchNavbarMenuItems() {
      const loadingStore = useLoadingStore();
      loadingStore.startLoading();
      this.isLoading = true;
      this.error = null;
      try {
        const response = await axios.get("/api/Menu/GetNavbarMenus");

        response.data.Payload.forEach((element) => {
          if (element.GroupName === "navbar") {
            this.navbarMenu = element.Menus;
          } else if (element.GroupName === "AuthFooter") {
            this.authMenu = element.Menus;
          }
        });
      } catch (error) {
        this.error = "Menü alınırken bir hata oluştu";
      } finally {
        this.isLoading = false;
        loadingStore.finishLoading();
      }
    },
    async fetchFooterMenuGroups() {
      const loadingStore = useLoadingStore();
      loadingStore.startLoading();
      this.isLoading = true;
      this.error = null;
      try {
        const response = await axios.get("/api/Menu/GetFooterMenus");
        this.footerMenuGroups = response.data.Payload;
      } catch (error) {
        this.error = "Menü alınırken bir hata oluştu";
      } finally {
        this.isLoading = false;
        loadingStore.finishLoading();
      }
    },
  },
});
